import { render, staticRenderFns } from "./zrdata.vue?vue&type=template&id=5020ec92&scoped=true"
import script from "./zrdata.vue?vue&type=script&lang=js"
export * from "./zrdata.vue?vue&type=script&lang=js"
import style0 from "./zrdata.vue?vue&type=style&index=0&id=5020ec92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5020ec92",
  null
  
)

export default component.exports